module.exports = __webpack_public_path__ + "static/media/item_7_1_comp.64cfc4e1.png";